import { SquirrelStatusCodeToCommerceStatusCodeMap } from '../constants.js';
import { isCommerceSquirrelOffer } from '../typeGuards/squirrel.js';
/**
 * Extract valid ids from a set of valid ids, this will
 */
export function identifyItemIds(items, identiferType) {
    const results = [];
    for (const item of items) {
        const id = item[identiferType];
        if (id !== undefined) {
            results.push(id);
        }
    }
    return results;
}
export function identifyItemId(item, idType) {
    return item.identifiers[idType];
}
export function identifyMissingItems(fullList, itemSet, identiferType) {
    //@todo extremely inefficient implementation, good enough for now
    return fullList.filter((itemIds) => findItemInSet(itemIds, itemSet, identiferType) === undefined);
}
export function findItemInSet(subject, itemSet, identiferType) {
    const subjectId = subject[identiferType];
    if (subjectId === undefined) {
        return undefined;
    }
    for (const item of itemSet) {
        if (subjectId === item.identifiers[identiferType]) {
            return item;
        }
    }
    return undefined;
}
/**
 * Build source set string from a commerce item image
 */
export function buildCommerceImageSrcSet(image) {
    return image?.sizes?.map((size) => `${size.src} ${size.width}w`).join(', ') ?? '';
}
export function getItemCompletionStatus(item) {
    if (item.requestStatus) {
        return item.requestStatus;
    }
    if (item.offers.length === 0) {
        // If we don't have a status on the item manually or any offers, we will consider it complete
        //@todo is this ..uh... the right thing to do?  Let's keep it in mind
        return 'Complete';
    }
    let hasErrors = false;
    let hasCompletion = false;
    for (const offer of item.offers) {
        const status = getOfferCompletionStatus(offer);
        if (status === 'Pending') {
            return 'Pending';
        }
        if (status === 'Error') {
            hasErrors = true;
        }
        if (status === 'Complete') {
            hasCompletion = true;
        }
    }
    if (hasCompletion) {
        return hasErrors ? 'CompleteWithError' : 'Complete';
    }
    if (hasErrors) {
        return 'Error';
    }
    // Same as above, if we don't have any status information we consider it complete
    return 'Complete';
}
/**
 * Get the CommerceApiRequestStatus for an offer
 *
 * This is mostly meaningful for Squirrel offers, but normallizes
 */
export function getOfferCompletionStatus(offer) {
    if (isCommerceSquirrelOffer(offer)) {
        return getSquirrelStatusEquivalent(offer.metaData.squirrelOfferStatus);
    }
    return 'Complete';
}
/**
 * Get the CommerceApiRequestStatus for a squirrel status
 *
 * If we don't have status information, consider it complete
 */
export function getSquirrelStatusEquivalent(squirrelStatus) {
    if (squirrelStatus === undefined) {
        return 'Complete';
    }
    return SquirrelStatusCodeToCommerceStatusCodeMap[squirrelStatus];
}
/**
 * Convert IdentiferSet to array of strings
 *
 * @param identifiers
 * @returns array of identifiers as strings
 */
export function commerceIdentifierSetToStringArray(identifiers) {
    const result = [];
    for (const [idType, id] of Object.entries(identifiers)) {
        result.push(`${idType}: ${id}`);
    }
    return result;
}
//# sourceMappingURL=items.js.map